module.exports = __webpack_public_path__ + "static/media/timelify-normal.79fe5d72.otf";